import { IconCheckCircle } from '@sequencehq/core-components'
import { SimplePaymentPage } from 'modules/PaymentsApp/components/SimplePaymentPage'

export const Success = () => {
  return (
    <SimplePaymentPage
      icon={IconCheckCircle}
      iconColour="green.60"
      header="Payment successful"
      subheader="You have been successfully charged for the invoice."
      nextSteps={[
        'Your payment details have been saved for recurring payments. To change the current payment method you can contact the issuer.'
      ]}
    />
  )
}
